import { MoongateLogoColorBlack } from "@assets";
import { Text } from "@chakra-ui/react";
import { NextImage } from "@components/NextImage/NextImage";
import { AcreWorldLogo, PlatinumBayLogo } from "../../public";

const EventDetailAbout = () => {
  return (
    <div className="w-full px-0 mb-16">
      <div className="text-2xl font-bold mb-4 capitalize dark:text-white">
        <Text fontSize="2xl" fontWeight="bold">
          About
        </Text>
      </div>

      <div className="mb-16 px-0 mb-16 w-full" style={{ fontWeight: 500 }}>
        <div className="flex justify-center">
          <NextImage
            className="w-64 mb-4"
            src={PlatinumBayLogo}
            alt="platinum-bay-logo"
          />
        </div>
        <Text fontSize="lg" className="space-y-6">
          This NFT collection represents your exclusive asset ownership to the
          ADM Platinum Bay in Phuket, Thailand.
          <br /> <br />
          The product does not carry any form of passive income. NFT holders may
          choose to redeem their NFTs for one of the 9 handpicked condominium
          units at a later date, subject to terms and conditions. For more
          details, please refer to&nbsp;
          <a
            href="https://platinumbaynft.com"
            target="_blank"
            rel="noreferrer"
            className="text-primary underline cursor-pointer"
          >
            platinumbaynft.com
          </a>
        </Text>

        <div className="flex justify-center">
          <NextImage
            className="w-64 mt-8 mb-4"
            src={AcreWorldLogo}
            alt="acre-world-logo"
          />
        </div>
        <Text fontSize="lg" className="space-y-6">
          Acre World is a pioneering platform in the field of Real World Asset
          (RWA) tokenization, with a mission to bridge the traditional and web3
          world. As the incubator of the Platinum Bay NFT project, Acre World
          aims to bring real-world businesses to the Blockchain, offering reward
          mechanisms tied to the nature of business partners and ensuring
          liquidity through our entire ecosystem (Launchpad, DeFi protocols, and
          Marketplace).
          <br /> <br />
          Acre World facilitates asset tokenization from partner companies,
          thereby democratizing participation from global customers and lowering
          entry barriers to an otherwise exclusive market.
        </Text>

        <div className="flex justify-center">
          <NextImage
            className="w-64 mt-8 mb-4"
            src={MoongateLogoColorBlack}
            alt="moongate-logo"
          />
        </div>
        <Text fontSize="lg" className="space-y-6">
          Moongate (
          <a
            href="https://twitter.com/0xMoongate"
            target="_blank"
            rel="noreferrer"
            className="text-primary underline cursor-pointer"
          >
            @OxMoongate
          </a>
          ) is building the underlying technology to drive the mass adoption of
          smart tickets and memberships. Through our platform, brands and
          businesses can easily create customized NFT digital assets that
          seamlessly integrates into real world operation.
          <br /> <br />
          To date, we have worked with a broad range of conferences, F&B chains,
          retail brands, and hospitality groups with our technology
          implementation; our product has been used by tens of thousands of end
          users, and has proven to drive customer engagement and revenue.
        </Text>
      </div>
    </div>
  );
};

export default EventDetailAbout;
